import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Window.svg",
  "use": "Window.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Window.svg\"><path d=\"M51.01,54.0208h-38a5,5,0,0,1-5-5v-34a5,5,0,0,1,5-5h38a5,5,0,0,1,5,5v34A5,5,0,0,1,51.01,54.0208Zm-37-40a2,2,0,1,0,2,2A2,2,0,0,0,14.0106,14.0209Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,20.0106,14.0209Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,26.0106,14.0209Zm26,9a1,1,0,0,0-1-1h-38a1,1,0,0,0-1,1v26a1,1,0,0,0,1,1h38a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol